import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import ListadoRondas from './components/ListadoRondas';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allRondasAction, setActivoRondasAction } from './RondasAction';
import FormRondas from './components/FormRondas';
import { ModalComponent } from '../../../widgets';

const RondasView = () => {
  const dispatch = Redux.useDispatch();

  const rondasStore = Redux.useSelector((state) => state.rondas);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoRondasAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
          ml={2}
          mt={2}
          mb={1}
        />
        <BotonComponent
          mt={2}
          mb={1}
          click={async () => {
            await setActivoRondasAction(dispatch, null);
            await allRondasAction(dispatch, rondasStore.params);
          }}
          disabled={rondasStore.all.length === 0 || rondasStore.loadingAll}
          white
          refreshIcon
          text={rondasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoRondas setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <ModalComponent
        id="modalFormRondas"
        title={`${
          rondasStore.activo
            ? `Editar ${rondasStore.activo.nombre}`
            : 'Nueva ronda'
        }`}
        maxWidth="sm"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormRondas
          activo={rondasStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default RondasView;
